<script>
import { assign, isEmpty } from 'lodash'
import { warning, success } from '@/utils/alert'

export default {
  name: 'ChangePassword',
  data: () => ({
    credentials: {
      current_password: null,
      password: null,
      confirmation: null
    }
  }),
  methods: {
    doChange () {
      const credentials = assign({}, this.credentials)
      if (isEmpty(credentials.current_password)) {
        warning('Favor informar a senha atual.')
      }
      if (isEmpty(credentials.password) && !isEmpty(credentials.current_password)) {
        warning('Favor informar a nova senha.')
      }
      const passwordIsOk = credentials.password === credentials.confirmation
      if (!passwordIsOk) {
        warning('As senha devem se ser iguais')
      }

      delete credentials.confirmation

      this.$resource.update('', credentials)
        .then(({data}) => {
          this.credentials = {
            current_password: null,
            password: null,
            confirmation: null
          }
          success('Senha alterada com sucesso!.')
        })
    }
  },
  resourcePath: '/v1/settings/users/me/password'
}
</script>

<template lang="pug">
  #menu-password-mobile.collapse
    .col-xs-12.col-sm-12.p-top-10
      f-password(placeholder="Senha atual", v-model="credentials.current_password")
    .col-xs-12.col-sm-12.p-top-10
      f-password(placeholder="Nova senha", v-model="credentials.password")
    .col-xs-12.col-sm-12.p-top-10
      f-password(placeholder="Confirme a nova senha", v-model="credentials.confirmation")
    .col-xs-12.col-sm-12.p-top-10
      button.btn.save(@click.prevent="doChange()", type="button")
        span.icon 
        |  Salvar Alteraçãoes
    .clearfix
</template>



// WEBPACK FOOTER //
// src/layout/headers/changePasswordMobile.vue